import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "space-y-10" }
const _hoisted_2 = { class: "font-bold text-3xl lg:text-4xl text-indigo-300" }
const _hoisted_3 = { class: "grid gap-y-3 sm:grid-cols-2 sm:gap-4" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-title" }


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const sections = [
  {
    title: "Teaching CS made easy",
    text: "Streamlining and simplifying your teaching, assessment, collaboration and administration of CS courses.",
    featureList: [
      {
        title: "Assessment suite",
        text: "Streamlined inteface for assignment creation and grading, with automated testing, plagiarism detection, and complete auditability of student submissions.",
      },
      {
        title: "Data-driven insights",
        text: "Analyzing user interactions with the system enables us to automatically recognize at-risk students, allowing instructors to intervene in a timely manner.",
      },
    ],
  },

  {
    title: "Learning CS made effective",
    text: "Eliminating barriers to entry for students and enabling easy collaboration with peers and teachers.",
    featureList: [
      {
        title: "Zero setup",
        text: "Everything just works and is accessible online. No need to install or maintain anything, allowing students to focus on their learning.",
      },
      {
        title: "Student-centric tools",
        text: "Collaborative text editors and terminals, shared whiteboards, text and video chat allow students to get help quickly and effectively.",
      },
    ],
  },

  {
    title: "Mastering CS made natural",
    text: "Facilitating student mastery of the material by enabling them to learn in real-world development environments.",
    featureList: [
      {
        title: "Linux",
        text: "Students learn how to interact with computers through the Linux command line, familiatizing them with most widely used server operating system.",
      },
      {
        title: "Industry standard practices",
        text: "With built-in support for git, unit testing, and code reviews, students get early exposure to the way companies work in the real world.",
      },
    ],
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sections, (section, index) => {
      return _createElementVNode("div", {
        class: "w-full max-w-screen-lg text-left space-y-5",
        key: `section-${index}`
      }, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(section.title), 1),
        _createElementVNode("p", null, _toDisplayString(section.text), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.featureList, (feature, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card shadow bordered bg-base-100",
              key: `feature-${index}`
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", _hoisted_5, _toDisplayString(feature.title), 1),
                _createElementVNode("p", null, _toDisplayString(feature.text), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    }), 64))
  ]))
}
}

})